export const getYears = () => {
    const yearItems = []
    for(let  year = new Date().getFullYear()+1; year >= 1992; year-- ) {
        yearItems.push({id: year, name: year})
    }
    return yearItems
}